import { DragDropContext } from "@hello-pangea/dnd";
import { Paper, Box } from "@mui/material";
import React from "react";

import { BusinessService } from "0.Mine/3.Interfaces/Services";

import { useTreatmentTable } from "../Logic/TreatmentTable";
import { DesktopView } from "../UI/ServiceTable";

interface TreatmentTableProps {
  businessid: number;
  treatments: BusinessService[];
  onAdd: (treatment: BusinessService) => void;
  onDelete: (index: number) => void;
  onReorder: (treatments: BusinessService[]) => void;
  onUpdate: (treatment: BusinessService) => void; // Add this prop
}

const TreatmentTable: React.FC<TreatmentTableProps> = ({
  businessid,
  treatments,
  onAdd,
  onDelete,
  onReorder,
  onUpdate, // Add this prop
}) => {
  const {
    isAdding,
    setIsAdding,
    expandedRows,
    newTreatment,
    fileInputRef,
    toggleRow,
    handleSubmit,
    handleImageUpload,
    triggerFileInput,
    handleDragEnd,
    handleNewTreatmentChange,
    cancelAdding,
    // Add these new properties
    isEditing,
    setIsEditing,
    editingTreatment,
    setEditingTreatment,
    handleEditTreatmentChange,
    handleEditSubmit,
  } = useTreatmentTable(businessid, treatments, onAdd, onDelete, onReorder, onUpdate);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Paper
          elevation={1}
          sx={{
            borderRadius: 2,
            width: "100%",
            display: "inline-block",
            minWidth: "100%",
          }}
        >
          <DesktopView
            treatments={treatments}
            isAdding={isAdding}
            setIsAdding={setIsAdding}
            newTreatment={newTreatment}
            handleNewTreatmentChange={handleNewTreatmentChange}
            handleSubmit={handleSubmit}
            cancelAdding={cancelAdding}
            triggerFileInput={triggerFileInput}
            fileInputRef={fileInputRef}
            handleImageUpload={handleImageUpload}
            onDelete={onDelete}
            // Add these new props
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            editingTreatment={editingTreatment}
            setEditingTreatment={setEditingTreatment}
            handleEditTreatmentChange={handleEditTreatmentChange}
            handleEditSubmit={handleEditSubmit}
          />
        </Paper>
      </Box>
    </DragDropContext>
  );
};

export default TreatmentTable;
